<template>
  <el-dialog
    title="密钥信息"
    :visible.sync="visible"
    width="600px"
  >
    <el-form :model="keyForm" label-width="100px">
      <el-form-item :label="$t('openApiAuth.merchantName')">
        <el-input v-model="keyForm.storeName" disabled></el-input>
      </el-form-item>
      <el-form-item label="应用ID">
        <el-input v-model="keyForm.appId" disabled></el-input>
      </el-form-item>
      <el-form-item label="应用名称">
        <el-input v-model="keyForm.appName" disabled></el-input>
      </el-form-item>
      <el-form-item label="App Key">
        <el-input v-model="keyForm.appKey" disabled>
          <template slot="append">
            <el-button @click="copyText(keyForm.appKey)">复制</el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="公钥">
        <el-input type="textarea" v-model="keyForm.publicKey" disabled rows="4"></el-input>
        <el-button type="text" @click="copyText(keyForm.publicKey)">复制公钥</el-button>
      </el-form-item>
      <el-form-item label="私钥">
        <el-input type="textarea" v-model="keyForm.privateKey" disabled rows="4"></el-input>
        <el-button type="text" @click="copyText(keyForm.privateKey)">复制私钥</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'KeyInfoDialog',
  data() {
    return {
      visible: false,
      keyForm: {
        storeName: '',
        appId: '',
        appName: '',
        appKey: '',
        publicKey: '',
        privateKey: ''
      }
    }
  },
  methods: {
    open(keyInfo) {
      this.keyForm = {
        storeName: keyInfo.storeName || '',
        appId: keyInfo.appId || '',
        appName: keyInfo.appName || '',
        appKey: keyInfo.appKey || '',
        publicKey: keyInfo.publicKey || '暂未获取',
        privateKey: keyInfo.privateKey || keyInfo.appSecret || '暂未获取'
      }
      this.visible = true
    },
    copyText(text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$message.success('复制成功')
    }
  }
}
</script>